import React from 'react'
import "./index.scss"
function Footer() {
    return (
        <div className='footers flex justify-center pb-2.5 bg-[#ebf1ff]'><p>Copyright © 2023 <span>SQUAD INNOVATORS LTD.</span> All rights reserved</p></div>
    )
}

export default Footer